FreeShipping = window.FreeShipping ?= {}

FreeShipping.View = require './views/free_shipping'

FreeShipping.init = ({freeShippingAvailable}, done) ->
  return done() unless freeShippingAvailable?.hasOneFreeShipping
  $ ->
    {freeShippingValues} = freeShippingAvailable

    view = new FreeShipping.View
      el: '.free-shipping-container'
      freeShippingValues: freeShippingValues

    done()


module.exports = FreeShipping
